/* Shared lightweight behaviors used across the theme. */
(function () {
  // --- Quantity steppers (event delegation) ---
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-minus], [data-qty-plus]');
    if (!btn) return;
    var wrap = btn.closest('[data-qty]');
    var input = wrap && wrap.querySelector('[data-qty-input]');
    if (!input) return;
    var min = parseInt(input.getAttribute('min'), 10) || 1;
    var val = parseInt(input.value, 10) || min;
    val += btn.hasAttribute('data-qty-plus') ? 1 : -1;
    input.value = Math.max(min, val);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // --- Localization selectors submit their form on change ---
  document.addEventListener('change', function (e) {
    var select = e.target.closest('[data-localization-submit]');
    if (select && select.form) { select.form.submit(); }
  });

  // --- Auto-submit a form when a tagged control changes (facets, sort) ---
  document.addEventListener('change', function (e) {
    var el = e.target.closest('[data-auto-submit]');
    if (el) {
      var form = el.form || el.closest('form');
      if (form) form.submit();
    }
  });

  // --- Disclosure toggles: [data-toggle="#id"] shows/hides a target ---
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-toggle]');
    if (!trigger) return;
    var target = document.querySelector(trigger.getAttribute('data-toggle'));
    if (!target) return;
    e.preventDefault();
    var isOpen = target.hasAttribute('hidden');
    if (isOpen) { target.removeAttribute('hidden'); } else { target.setAttribute('hidden', ''); }
    trigger.setAttribute('aria-expanded', String(isOpen));
    if (trigger.dataset.toggleClass) {
      trigger.classList.toggle(trigger.dataset.toggleClass, isOpen);
    }
  });
})();
